import * as types from './mutations_type';
import api from '@/api/api.js';
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
import { Encrypt } from "@/utils/cryptoAES";
import Vue from 'vue';
import {Dialog} from 'vant' ;
Vue.use(Dialog);

export const state = {
    token:getToken(),              //token
	userInfo:'',
    expiresTime:'1111',            //过期时间
	isRunLogin:false,
	serchkey:'',                  //搜索关键词
	serchCon:'',                  //搜索信息
};
export const mutations = {
    [types.SET_TOKEN]: (s, token) => {
        s.token = token;
    },
    [types.SET_EXPIRESTIME]: (s, expiresTime) => {
        s.expiresTime = expiresTime;
    },
    [types.SET_USERINFO]: (s, userInfo) => {
        s.userInfo = userInfo;
    },
	[types.SET_ISRUNLOGIN]: (s, isRunLogin) => {
	    s.isRunLogin = isRunLogin;
	},
	[types.SET_SERCHKEY]: (s, serchkey) => {
	    s.serchkey = serchkey;
	},
	[types.SET_SERCHCON]: (s, serchCon) => {
	    s.serchCon = serchCon;
	},
};

export const actions = {
    /***
    *** 登录
    ***/
    Login({ commit },userInfo) {
        console.log(userInfo.userName)
        let info = {
            userName: userInfo.userName.trim(),
            password: userInfo.password,
        }
        return new Promise((resolve, reject) => {
            api.getLogin(info).then(res => {
				console.log(res.result)
				if(res.result==1){
					commit('setUserInfo', res.resultMsg);
					commit('setIsrunlogin', true);
					Dialog.alert({
						title: '温馨提示',
						message: '登录成功',
					});
					resolve(res.resultMsg);
				}else if(res.result==0){
					Dialog.alert({
						title: '温馨提示',
						message: res.resultMsg,
					})
					return;
				}
            }).catch(error => {
                reject(error)
            })
        })
    },
    /***
    *** @ token 过期 退出登录
    *** @ 前端退出
    ***/
    async LogOut({ commit, state }) {
        await api.getLogout().then(res => {
            if(res.result == 1){
				commit('setUserInfo', '');
				commit('setIsrunlogin', false);
                resolve(res);
            }
        }).catch(err => {
        	reject(error)
        })
    },
    /***
    *** @ 登录后获取用户信息
    ***/
    GetInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            api.getInfo(state.token).then(res => {
                if(res.code == 200){
                    commit('setUserInfo',res.user);
                    console.log(state.userInfo)
                    resolve();
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
};
